import { createEvent } from "library/local-events"

export const ToBeSaved = createEvent("ToBeSaved")

/** Raised when useSave skips persistence because the target matches the last saved snapshot. */
export const SaveSkippedUnchanged = createEvent("SaveSkippedUnchanged")
